import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_URL_UTIL } from '@core/utils';
import { Observable } from 'rxjs';
import { UserDetails } from '../models/user.modal';

@Injectable({
  providedIn: 'root',
})
export class UserDetailsService {
  user!: UserDetails;
  constructor(private readonly httpClient: HttpClient) {}

  setUser(user: UserDetails): void {
    this.user = user;
  }

  getUser(): UserDetails {
    return this.user;
  }

  getUserDetails(): Observable<UserDetails> {
    return this.httpClient.get<UserDetails>(`${API_URL_UTIL.microsoftLogin.userDetails}`);
  }
}
